import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import useRequestPending from 'shared/hooks/useRequestPending'
import {
    selectedCreditCardSelector,
    selectedVehicleSelector,
    parkingModeSelector,
    rateSelector,
    makePurchasePendingSelector,
} from 'booking/selectors'

import { addressToStringSelector } from 'auth/selectors'
import { getBookingValidationErrors, validationErrorsInitialState } from 'booking/utils'

const useBookingValidation = () => {
    const [validationErrors, setValidationErrors] = React.useState(validationErrorsInitialState)
    const makePurchasePending = useSelector(makePurchasePendingSelector)
    const parkingMode = useSelector(parkingModeSelector)
    const deliveryAddress = useSelector(addressToStringSelector)
    const selectedVehicle = useSelector(selectedVehicleSelector)
    const selectedCreditCard = useSelector(selectedCreditCardSelector)
    const { error, isLoading } = useRequestPending(makePurchasePending)
    const rate = useSelector(rateSelector)

    const updateValidation = objectToUpdate =>
        setValidationErrors({
            ...validationErrors,
            ...objectToUpdate,
        })

    const validateBooking = useCallback(
        ({ purchaseValidation = false } = {}) => {
            const { errors, isValid } = getBookingValidationErrors({
                rate,
                parkingMode,
                deliveryAddress,
                selectedVehicle,
                purchaseValidation,
                selectedCreditCard,
            })

            setValidationErrors(errors)

            return { isValid }
        },
        [rate, parkingMode, deliveryAddress, selectedVehicle, selectedCreditCard]
    )

    return {
        validateBooking,
        validationErrors,
        setValidationErrors,
        error,
        isLoading,
        updateValidation,
    }
}

export default useBookingValidation
